<template>
  <v-btn
    :append-icon="mdiArrowRight"
    :color="secondary ? secondaryColor || 'primary' : primaryColor || 'primary'"
    :href="value.popup_contact_form_config ? undefined : value.href"
    :target="hrefTarget(value.href)"
    :variant="secondary ? 'outlined' : undefined"
    exact
    size="large"
  >
    {{ value.action }}

    <v-dialog
      v-if="value.popup_contact_form_config"
      v-model="contactFormDialog"
      activator="parent"
      scrollable
      width="auto"
    >
      <ContactFormCard
        show-close
        :value="value.popup_contact_form_config"
        @close="contactFormDialog = false"
      />
    </v-dialog>
  </v-btn>
</template>

<script setup lang="ts">
import type { DirectusSchema } from '#root/types/content'
import { ref } from 'vue'
import { mdiArrowRight } from '@mdi/js'
import { hrefTarget } from '#root/lib/utils'

withDefaults(
  defineProps<{
    primaryColor?: string
    secondary?: boolean
    secondaryColor?: string
    value: DirectusSchema['cta']
  }>(),
  {
    primaryColor: undefined,
    secondary: false,
    secondaryColor: undefined
  }
)

const contactFormDialog = ref(false)
</script>
